// extracted by mini-css-extract-plugin
module.exports = {"NoFlux":"NoFluxView_NoFlux__2pxZt","Inner":"NoFluxView_Inner__1gSN6"};